import { render, staticRenderFns } from "./content-item.vue?vue&type=template&id=4d4d61b7"
import script from "./content-item.vue?vue&type=script&lang=js"
export * from "./content-item.vue?vue&type=script&lang=js"
import style0 from "./content-item.vue?vue&type=style&index=0&id=4d4d61b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports